import { Enum } from './Enum';

export class CalendarItemTypeEnum extends Enum {
    static Meeting = 'meeting';
    static Reminder = 'reminder';
    static Task = 'task';
    static Education = 'education';

    static items = [{
        id: CalendarItemTypeEnum.Meeting,
        name: 'Событие'
    }, {
        id: CalendarItemTypeEnum.Reminder,
        name: 'Напоминание'
    }, {
        id: CalendarItemTypeEnum.Task,
        name: 'Задача'
    }, {
        id: CalendarItemTypeEnum.Education,
        name: 'Обучение'
    }];
}

